export default "__VITE_ASSET__Do7icpk9__ 584w";